// extracted by mini-css-extract-plugin
export var avatarContainer = "_au-0";
export var avatarTypingWave = "_au-i";
export var gray = "_au-f";
export var green = "_au-c";
export var icon = "_au-9";
export var image = "_au-1";
export var lg = "_au-6";
export var md = "_au-5";
export var presenceDot = "_au-b";
export var red = "_au-d";
export var sm = "_au-4";
export var status = "_au-a";
export var typingDot = "_au-h";
export var typingPill = "_au-g";
export var xl = "_au-7";
export var xs = "_au-3";
export var xxl = "_au-8";
export var xxs = "_au-2";
export var yellow = "_au-e";